import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {FetchWeeksListRequest,} from "../../core/behavior-tracker.actions";
import {filter, Subject, takeUntil} from "rxjs";
import {ActivatedRoute, Router} from "@angular/router";
import {Store} from "@ngrx/store";
import * as fromRoot from "../../../../../state/app.state";
import {CommonService} from "../../../../shared/services/common.service";
import {MatSort} from "@angular/material/sort";
import {MatTable, MatTableDataSource} from "@angular/material/table";
import {
  profile,
  selectedUserProfile
} from "../../../../shared/core/shared.selectors";
import {roles} from "../../../../shared/constants/common.constants";
import {groupInfo, weekListInfo} from "../../core/behavior-tracker.selectors";
import {SetWeekInfoForContract} from "../../../../shared/core/shared.actions";
import {WeekList} from 'src/app/models/week-list';
import * as moment from 'moment';

@Component({
  selector: 'app-week-list-table',
  templateUrl: './week-list-table.component.html',
  styleUrls: ['./week-list-table.component.css']
})
export class WeekListTableComponent implements OnInit, OnDestroy {
  @ViewChild(MatTable) table: MatTable<any>;
  @ViewChild(MatSort) sort: MatSort;

  weekListLoading: boolean = false;
  weeksListData: WeekList;
  tableData: any[];
  dataSource: any = new MatTableDataSource();
  displayedColumns = [
    'weekNumber',
    'date',
    'weight',
    'numberOfDaysCompleted',
    'redLights',
    'physicalActivity',
    'screenTime',
    'contractId',
    'sessions',
  ];
  sortColumn: any;
  sortOrder: any;
  contractStatusIconNameMapConfig = {
    true: 'contract-met', // Contract successful
    false: 'contract-not-met' // Contract not successful
  }
  contractStatusIconClassNameMapConfig = {
    1: 'contract-met-icon', // Contract successful
    2: 'contract-not-met-icon' // Contract not successful
  }
  isFirstPage = true;
  selectedWeek: any;
  role: number;
  selectedUserRole: number;
  groupId: number;
  selectedGroupId: number;
  previousUrl: string;
  private readonly onDestroy: Subject<any> = new Subject<any>();
  showDetailsForAdult = false;
  isGroupNotStarted = false;
  goalsContractsTooltipText = 'Green check mark indicates contract has been signed by both the participant and their adult.';

  constructor(
    private router: Router,
    private store: Store<fromRoot.State>,
    private commonService: CommonService,
    private route: ActivatedRoute
  ) {

    this.commonService
      .onNavigationEnd
      .pipe(takeUntil(this.onDestroy))
      .subscribe((d) => {
        this.previousUrl = d.url;
      });

    this.store.select(profile)
      .pipe(takeUntil(this.onDestroy))
      .subscribe(data => {
        this.role = data?.role
        this.groupId = this.role === roles['adult'] ? -1 : data?.groupId
        if (!this.route?.snapshot?.params['memberId']) {
          this.fetchWeeksList();
        }
        if (!this.route?.snapshot?.params['memberId']) {
          this.showDetailsForAdult = data?.role === roles.adult;
          this.manageColumnsToDisplay();
        }
      });
    this.store.select(selectedUserProfile)
      .pipe(takeUntil(this.onDestroy),
        filter((data) => !!data.profile))
      .subscribe(data => {
        this.selectedUserRole = data?.profile?.role
        this.selectedGroupId = this.selectedUserRole === roles['adult'] ? -1 : data?.profile?.groupId
        if (this.route?.snapshot?.params['memberId']) {
          this.fetchWeeksList();
        }
        if (this.route?.snapshot?.params['memberId']) {
          this.showDetailsForAdult = data?.profile?.role === roles.adult;
          this.manageColumnsToDisplay();
        }
      });

    this.store.select(groupInfo)
      .pipe(takeUntil(this.onDestroy))
      .subscribe(data => {
        if (data?.['startDate']) {
          this.isGroupNotStarted = moment(data['startDate']).isAfter(moment());
        }
      });

  }

  manageColumnsToDisplay() {
    if ((!this.route?.snapshot?.params['memberId'] && this.role === roles['adult'])
    || (this.route?.snapshot?.params['memberId'] && this.selectedUserRole === roles['adult'])) {
      this.displayedColumns = [
        'weekNumber',
        'date',
        'weight',
        'numberOfDaysCompleted',
        'redLights',
        'physicalActivity',
        'screenTime',
        // 'contractId',
        // 'sessions',
      ]
    }
  }

  ngOnInit() {
    this.store.select(weekListInfo)
      .pipe(
        takeUntil(this.onDestroy),
        filter(data => !!data)
      )
      .subscribe(data => {
        this.weekListLoading = data.loading;
        this.weeksListData = data;

        if (!data.loading) {
          this.dataSource.data = [...data?.list];

          setTimeout(() => {
            if (this.sortColumn && data?.pageNumber === 1) {
              this.commonService.scrollColumnInView(this.sortColumn)
            }
          }, 0)

          if (data?.hasNext) {
            setTimeout(() => {
              // check window height for infinite scroll
              this.commonService.checkInfiniteScrollHeightAndCallNext('table-wrapper', () => {
                this.onScroll();
              });
            }, 0)
          }
        }

      })

  }

  onScroll() {
    if (this.weeksListData?.hasNext && !this.weeksListData?.loading) {
      this.fetchWeeksList(this.weeksListData.pageNumber + 1, this.weeksListData.limit);
      this.isFirstPage = false;
    }
  }

  fetchWeeksList(pageNumber = 1, limit = 26) {

    // Based On Discussion With Tech Lead Keeping the Limit as 26
    if (this.selectedGroupId || this.groupId) {
      this.store.dispatch(FetchWeeksListRequest({
        payload: {
          groupId: this.route.snapshot.params['memberId'] ? this.selectedGroupId : this.groupId,
          ...(this.route.snapshot.params['memberId'] ? {forUserId: Number(this.route.snapshot.params['memberId'])} : {}),
          pageNumber,
          limit,
          sortOrder: -1,
          sortColumn: 'weekNumber'
        }
      }));
    }
  }

  redirectToWeekDetails(data) {
    const url = this.router.url.split('?')[0];
    this.router.navigate([`/${url}`], {
      queryParams: {
        weekNumber: data?.weekNumber || -1
      }
    });
  }

  redirectToContracts(data) {
    const payload = {
      sessionNumber: data['lastSession'],
      weekNumber: data?.weekNumber,
      weekStartDate: data?.startDate,
      weekEndDate: data?.endDate,
      previousUrl: this.previousUrl,
    }
    this.store.dispatch(SetWeekInfoForContract(payload));

    const urlPrefix = this.router.url.split('/')[1];
    if (this.route.snapshot.params['memberId']) {
      this.router.navigate([`/${urlPrefix}/member/${this.route.snapshot.params['memberId']}/contract`]);
    } else {
      this.router.navigate([`/${urlPrefix}/contract`]);
    }
  }

  disableLink(weekStartDate) {
    const currentDate = moment();
    const startDate = moment(weekStartDate);

    return startDate.isAfter(currentDate);
  }

  ngOnDestroy() {
    this.onDestroy.next(null);
    this.onDestroy.complete();
  }

  protected readonly roles = roles;
}
